var $f1107d94c09df9b8$exports = {};
$f1107d94c09df9b8$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "\u041F\u0430\u043B\u0438\u0442\u0440\u0430 \u0446\u0432\u0435\u0442\u043E\u0432",
  "colorSwatch": "\u0446\u0432\u0435\u0442\u043E\u0432\u043E\u0439 \u043E\u0431\u0440\u0430\u0437\u0435\u0446",
  "transparent": "\u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u044B\u0439",
  "twoDimensionalSlider": "\u041F\u043E\u043B\u0437\u0443\u043D\u043E\u043A 2D"
};
export { $f1107d94c09df9b8$exports as default };